module.exports = __webpack_public_path__ + "img/cvnodata.3ba2448b.svg";